import baliImage from "../../assets/img/bali-img.webp";
import boraBoraImage from "../../assets/img/bora-bora.webp";
import brazilImage from "../../assets/img/brazil.webp";
import chinaImage from "../../assets/img/china.webp";
import denmarkImage from "../../assets/img/denmark.webp";
import republicImage from "../../assets/img/dominican.webp";
import DubaiDelightIMage from "../../assets/img/dubai-delight-img.webp";
import dubaiImage from "../../assets/img/dubai.webp";
import frenchImage from "../../assets/img/french.webp";
import greeceImage from "../../assets/img/greece.webp";
import hawaiiImage from "../../assets/img/Hawaii.webp";
import japanImage from "../../assets/img/japan.webp";
import jordanImage from "../../assets/img/jordan.webp";
import londonImage from "../../assets/img/london.webp";
import luciaImage from "../../assets/img/lucia.webp";
import MaldivesRetreatImage from "../../assets/img/maldives-retreat-img.webp";
import maldivesImage from "../../assets/img/maldives.webp";
import namibiaImage from "../../assets/img/namibia.webp";
import nigeriaImage from "../../assets/img/nigeria.webp";
import ontarioImage from "../../assets/img/ontario.webp";
import ParisGatewayImage from "../../assets/img/paris-gateway-img.webp";
import parisImage from "../../assets/img/paris.webp";
import romeImage from "../../assets/img/rome.webp";
import service1 from "../../assets/img/service-1.png";
import service2 from "../../assets/img/service-2.png";
import service3 from "../../assets/img/service-3.png";
import spainImage from "../../assets/img/spain.webp";
import victoriaImage from "../../assets/img/victoria.webp";
import hurawalhiImage from "../../assets/img/hurawalhi-img.webp";
import frenchHurawalhiImage from "../../assets/img/french-hurawalhi-island-img.webp";
import barcelonaImage from "../../assets/img/barcelona-beach.webp";

import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  LocationSecondIcon,
  ServiceIcon1,
  ServiceIcon2,
  ServiceIcon3,
  StarIcon,
  TwitterIcon,
  Work1,
  Work2,
  Work3,
  Work4,
} from "./Icons";

export const workList = [
  {
    icon: <ServiceIcon1 />,
    title: "CONTACT",
    description: "+1 (800) 555-TRIP",
    description2: "support@tripnest.com",
  },
  {
    icon: <ServiceIcon2 />,
    title: "Hours",
    description: "Mon–Fri: 9:00 AM – 6:00 PM",
    description2: "Sat–Sun: 10:00 AM – 4:00 PM",
  },
  {
    icon: <ServiceIcon3 />,
    title: "Location",
    description: "123 Explorer Lane, Wanderlust ",
    description2: "City, 10001",
  },
];
export const howItWorkList = [
  {
    icon: <Work1 />,
    title: "Choose Your Trip",
    description:
      "Select from flights, hotels, or custom travel packages that match your needs and budget.",
  },
  {
    icon: <Work2 />,
    title: "Customize Your Experience",
    description:
      "Add extras like car rentals, guided tours, or travel insurance — all in just a few clicks.",
  },
  {
    icon: <Work3 />,
    title: " Clear, Honest Pricing",
    description:
      "No surprises. All prices are upfront and transparent — what you see is what you pay.",
  },
  {
    icon: <Work4 />,
    title: " Book & Go",
    description:
      "Enjoy fast, secure booking and get ready to explore your next destination with ease.",
  },
];

export const NAVBAR_LIST = [
  { title: "Home", link: "/" },
  { title: "About Us", link: "/about-us" },
  { title: "Flights ", link: "/explore-flights" },
  { title: "Destination", link: "/destination" },
  { title: "Contact Us", link: "/contact-us" },
];

export const COMPANY_LINKS = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about-us" },
  { label: "Package", href: "/" },
  { label: "Testimonials", href: "/" },
  { label: "Blogs", href: "/contact-us" },
];

export const INFO_LINKS = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Use", href: "/terms-of-use" },
];

export const SOCIAL_LINKS = [
  {
    img: <LinkedinIcon />,
    link: "https://www.linkedin.com/",
  },
  {
    img: <InstagramIcon />,
    link: "https://www.instagram.com/",
  },

  {
    img: <FacebookIcon />,
    link: "https://www.facebook.com/",
  },
  {
    img: <TwitterIcon />,
    link: "https://www.twitter.com/",
  },
];

export const DESTINATION_LIST = [
  {
    image: denmarkImage,
    place1: "Europe",
    place2: "Denmark",
    type: "Island",
    popularity: 80,
  },
  {
    image: greeceImage,
    place1: "Europe",
    place2: "Greece",
    type: "Island",
    popularity: 90,
  },
  {
    image: republicImage,
    place1: "Carbbean",
    place2: "Dominican Republic",
    type: "beach",
    popularity: 10,
  },
  {
    image: ontarioImage,
    place1: "Canada",
    place2: "Ontario",
    type: "Buildings",
    popularity: 50,
  },
  {
    image: hawaiiImage,
    place1: "North America",
    place2: "Hawaii",
    type: "beach",
    popularity: 70,
  },
  {
    image: nigeriaImage,
    place1: "Africa",
    place2: "Nigeria",
    type: "Island",
    popularity: 60,
  },
  {
    image: jordanImage,
    place1: "Middle East",
    place2: "Jordan",
    type: "beach",
    popularity: 50,
  },
  {
    image: chinaImage,
    place1: "Asia",
    place2: "China",
    type: "Buildings",
    popularity: 90,
  },
  {
    image: japanImage,
    place1: "Asia",
    place2: "Japan",
    type: "Buildings",
    popularity: 100,
  },
  {
    image: brazilImage,
    place1: "South America",
    place2: "Brazil",
    type: "Island",
    popularity: 100,
  },
  {
    image: namibiaImage,
    place1: "Africa",
    place2: "Namibia",
    type: "Deserts",
    popularity: 90,
  },
  {
    image: victoriaImage,
    place1: "Australia",
    place2: "Victoria",
    type: "Buildings",
    popularity: 90,
  },
];

export const BOOK_FLIGHT_LIST = [
  {
    backgroundImage: maldivesImage,
    place: "Maldives",
    island: "Hurawalhi Island",
    prize: "620",
  },
  {
    backgroundImage: frenchImage,
    place: "French",
    island: "Hurawalhi Island",
    prize: "620",
  },
  {
    backgroundImage: spainImage,
    place: "Spain",
    island: "Barcelona city beach",
    prize: "850",
  },
  {
    backgroundImage: parisImage,
    place: "Paris",
    island: "A Paris Adventure",
    prize: "600",
  },
  {
    backgroundImage: boraBoraImage,
    place: "Bora Bora",
    island: "An amazing journey",
    prize: "1500",
  },
  {
    backgroundImage: londonImage,
    place: "London",
    island: "An amazing journey",
    prize: "350",
  },
  {
    backgroundImage: romeImage,
    place: "Rome",
    island: "Explore your taste",
    prize: "200",
  },
  {
    backgroundImage: luciaImage,
    place: "St Lucia",
    island: "An amazing journey",
    prize: "446",
  },
  {
    backgroundImage: dubaiImage,
    place: "Dubai",
    island: "Explore your taste",
    prize: "230",
  },
];

export const SPECIAL_OFFERS_LIST = [
  {
    image: baliImage,
    place: "Bali Escape",
    dayNight: "5 Days 4 Nights",
    rating: "4.7",
    flights: "2 Flights",
    hotel: "1 Hotel",
    transfer: "2 Transfers",
    activities: "4 Activities",
    para1: "Beachside Resort Stay",
    para2: "Uluwatu Temple Tour",
    para3: "Sunset Dinner Cruise",
    originalPrize: "72,000",
    sellingPrize: "49,999",
  },
  {
    image: ParisGatewayImage,
    place: "Paris Gateway",
    dayNight: "5 Days 4 Nights",
    price: "620",
    rating: "4.7",
    flights: "2 Flights",
    hotel: "1 Hotel",
    transfer: "2 Transfers",
    activities: "4 Activities",
    para1: "Eiffel Tower Access",
    para2: "Seine River Cruise",
    para3: "Louvre Museum Tour",
    originalPrize: "98,000",
    sellingPrize: "79,999",
  },
  {
    image: DubaiDelightIMage,
    place: "Dubai Delight",
    dayNight: "4 days 3 Nights",
    price: "620",
    rating: "4.7",
    flights: "2 Flights",
    hotel: "1 Hotel",
    transfer: "2 Transfers",
    activities: "4 Activities",
    para1: "Desert Safari",
    para2: "Burj Khalifa Entry",
    para3: "City Tour + Marina Dinner",
    originalPrize: "82,000",
    sellingPrize: "59,999",
  },
  {
    image: MaldivesRetreatImage,
    place: "Maldives Retreat",
    dayNight: "4 days 3 Nights",
    price: "620",
    rating: "4.7",
    flights: "2 Flights",
    hotel: "1 Hotel",
    transfer: "2 Transfers",
    activities: "4 Activities",
    para1: "Overwater Villa",
    para2: "Snorkeling Package",
    para3: "Private Beach Access",
    originalPrize: "82,000",
    sellingPrize: "59,999",
  },
  {
    image: baliImage,
    place: "Bali Escape",
    dayNight: "5 Days 4 Nights",
    rating: "4.7",
    flights: "2 Flights",
    hotel: "1 Hotel",
    transfer: "2 Transfers",
    activities: "4 Activities",
    para1: "Beachside Resort Stay",
    para2: "Uluwatu Temple Tour",
    para3: "Sunset Dinner Cruise",
    originalPrize: "72,000",
    sellingPrize: "49,999",
  },
  {
    image: ParisGatewayImage,
    place: "Paris Gateway",
    dayNight: "5 Days 4 Nights",
    price: "620",
    rating: "4.7",
    flights: "2 Flights",
    hotel: "1 Hotel",
    transfer: "2 Transfers",
    activities: "4 Activities",
    para1: "Eiffel Tower Access",
    para2: "Seine River Cruise",
    para3: "Louvre Museum Tour",
    originalPrize: "98,000",
    sellingPrize: "79,999",
  },
  {
    image: DubaiDelightIMage,
    place: "Dubai Delight",
    dayNight: "4 days 3 Nights",
    price: "620",
    rating: "4.7",
    flights: "2 Flights",
    hotel: "1 Hotel",
    transfer: "2 Transfers",
    activities: "4 Activities",
    para1: "Desert Safari",
    para2: "Burj Khalifa Entry",
    para3: "City Tour + Marina Dinner",
    originalPrize: "82,000",
    sellingPrize: "59,999",
  },
  {
    image: MaldivesRetreatImage,
    place: "Maldives Retreat",
    dayNight: "4 days 3 Nights",
    price: "620",
    rating: "4.7",
    flights: "2 Flights",
    hotel: "1 Hotel",
    transfer: "2 Transfers",
    activities: "4 Activities",
    para1: "Overwater Villa",
    para2: "Snorkeling Package",
    para3: "Private Beach Access",
    originalPrize: "82,000",
    sellingPrize: "59,999",
  },
];

export const TABS_LIST = [
  {
    title: "Special Deals",
  },
  {
    title: "Popular",
  },
  {
    title: "Recommendation",
  },
  {
    title: "Best Prize",
  },
];

export const serviceData = [
  {
    imgUrl: service1,
    title: "Flights",
    desc: "Search Flights & Places Hire to our most popular destinations",
    btnText: "Show Filghts",
  },
  {
    imgUrl: service2,
    title: "Hotels",
    desc: "Search hotels & Places Hire to our most popular destinations",
    btnText: "Show Hotels",
  },
  {
    imgUrl: service3,
    title: "Group Tour",
    desc: "Discover new places together with our unforgettable group tours!",
    btnText: "Show Tour",
  },
];
export const POPULAR_DESTINATIONS_LIST = [
  {
    location: "Maldives",
    place: "Hurawanldi Island",
    image: hurawalhiImage,
    days: "7 Days Tour on 2 Person",
    rating: "4.7",
    price: "620",
  },
  {
    location: "French",
    place: "Hurawanldi Island",
    image: frenchHurawalhiImage,
    days: "7 Days Tour on 2 Person",
    rating: "4.7",
    price: "620",
  },
  {
    location: "Spain",
    place: "Barcelona city beach",
    days: "4 Days Tour on 2 Person",
    image: barcelonaImage,
    rating: "4.7",
    price: "850",
  },
  {
    location: "Maldives",
    place: "Hurawanldi Island",
    image: hurawalhiImage,
    days: "7 Days Tour on 2 Person",
    rating: "4.7",
    price: "620",
  },
  {
    location: "French",
    place: "Hurawanldi Island",
    image: frenchHurawalhiImage,
    days: "7 Days Tour on 2 Person",
    rating: "4.7",
    price: "620",
  },
  {
    location: "Spain",
    place: "Barcelona city beach",
    days: "4 Days Tour on 2 Person",
    image: barcelonaImage,
    rating: "4.7",
    price: "850",
  },
];
